import React from 'react';
import AccessKeyForm from './AccessKeyForm';
import styles from '../../login/LoginForm/LoginFormCont.module.css';

const AccessKeyFormCont = () => (
  <div className={styles['login-container']}>
    <header className={styles.header}>
      <h3 className={styles.title}>Access Key Validation</h3>
      <p className={styles.des} />
      <h3 className={styles['email-header']}>Validate</h3>
      <hr />
    </header>
    <section>
      <AccessKeyForm />
    </section>
  </div>
);

export default AccessKeyFormCont;
